function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBathrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3,18V9c0-1.38,.56-2.63,1.46-3.54,.91-.9,2.16-1.46,3.54-1.46,1.64,0,3.09,.79,4,2.01",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 29,
    x2: 7,
    y2: 27,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 29,
    x2: 25,
    y2: 27,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.24,9.12c0,1.72-1.4,1.56-3.12,1.56s-3.12,.16-3.12-1.56,1.4-3.12,3.12-3.12,3.12,1.4,3.12,3.12Z",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,18v4.48c0,2.5-2.02,4.52-4.52,4.52H7.52c-2.5,0-4.52-2.02-4.52-4.52v-4.48H29Z",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 3,
    y2: 9,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12.75c0-.21-.17-.5-.37-.5s-.37,.29-.37,.5,.17,.25,.37,.25,.37-.04,.37-.25Z",
    style: {
      fill: "#69757c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,13.66c0-.48-.39-1.17-.87-1.17s-.87,.68-.87,1.17,.39,.58,.87,.58,.87-.1,.87-.58Z",
    style: {
      fill: "#69757c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.42c0-.48-.39-1.17-.87-1.17s-.87,.68-.87,1.17,.39,.58,.87,.58,.87-.1,.87-.58Z",
    style: {
      fill: "#69757c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,13.5c0-.21-.17-.5-.37-.5s-.37,.29-.37,.5,.17,.25,.37,.25,.37-.04,.37-.25Z",
    style: {
      fill: "#69757c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,15.75c0-.21-.17-.5-.37-.5s-.37,.29-.37,.5,.17,.25,.37,.25,.37-.04,.37-.25Z",
    style: {
      fill: "#69757c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathrooms);
export default __webpack_public_path__ + "static/media/bathrooms.e108e8131bbdb62482a5baf3a18f3477.svg";
export { ForwardRef as ReactComponent };